// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"b5a09c4d","258":"f62e20bf","365":"a06ff82c","589":"5439862a","961":"3526dfcd"}[chunkId] + ".chunk.js";
};